export default __webpack_public_path__ + "static/media/Webb.5bf2400a.png";